import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { SortButtons } from "components/common/SortButtons";
import AddFacility from "./AddFacility";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import { changeStatus } from "slices/facilitiesSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchFacilities } from "slices/facilitiesSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { removeMultipleFacilities } from "slices/facilitiesSlice";
const apiService = new Api();

function Facility() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { checkPermission } = usePermissions();
  const { facilities, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(facilitiesSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}
  });
  const refAddutton = React.useRef(null);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'abbreviation',
    sortDirection: 'desc',
    user_id: id
  });


  React.useEffect(() => {
    dispatch(fetchFacilities(1, { user_id: id }))
  }, [])

  const handleAddFacilityPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const submitCallback = (status, message) => {
    if (status) {

      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchFacilities(1, { user_id: id }))
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const handleRemoveItems = React.useCallback(() => {
    dispatch(removeMultipleFacilities({ ids: selectedItems }, submitCallback))
  }, [selectedItems])

  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(facilities.map((facility) => facility.id.toString()))
  }



  const renderTableHeader = React.useCallback(() => {

    const handleSort = (sortBy) => {
      if (sortConfig.sortDirection === 'desc') {
        setSortConfig({ sortBy, sortDirection: 'asc' })
        dispatch(fetchFacilities(currentPage, { user_id: id, sortBy: sortBy, sortDirection: 'asc', search: searchTerm }))
      }
      else {
        setSortConfig({ sortBy, sortDirection: 'desc' })
        dispatch(fetchFacilities(currentPage, { user_id: id, sortBy: sortBy, sortDirection: 'desc', search: searchTerm }))
      }
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Facilities') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Facility Name</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("name")}
              />
            </span>
          </div>
        </th>

        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Phone</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("name")}
              />
            </span>
          </div>
        </th>

        <th>
          <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            <p>Creation Date</p>
            <span>
              <SortButtons
                upActive={sortConfig.sortDirection == "asc"}
                downActive={sortConfig.sortDirection == "desc"}
                handleSort={() => handleSort("created_at")}
              />
            </span>
          </div>
        </th>
        {checkPermission('Status Facilities') &&
          <th >Status</th>
        }
        {checkPermission('Edit Facilities') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, facilities])


  const renderTableContent = React.useCallback(() => {
    return (
      facilities?.map((facility, index) => {
        return <FacilityItem facility={facility} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddFacilityPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      })
    )
  }, [facilities, selectedItems]);

  const handleClose = React.useCallback(() => {
    refAddutton.current.click();
    setAddForm({ show: false })
  }, [])


  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };

  const onBackButtonClick = () => {
    navigate('/clients/accounts');
  }
  return (
    <>
      <div className="content Tabs_content">
        <div className="nav_tab_area">
          <Link className="tabLink main_button active" to={`/clients/facilities/${id}`}>Facilities</Link>
          <Link className="tabLink main_button" to={`/clients/departments/${id}`}>Departments</Link>
        </div>
      </div>
      <ListLayout
        haveBackBtn={true}
        onBackButtonClick={onBackButtonClick}
        buttonTitle="Add Facility"
        height={'tab_height'}
        containerStyle={{ marginTop: '0' }}
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        addButtonDisabled={!checkPermission('Create Facilities')}
        totalPages={totalPages}
        selectedItems={selectedItems}
        fetchList={fetchFacilities}
        handleRemoveItems={handleRemoveItems}
        renderAddForm={(callback) => <AddFacility item={addForm.item} userId={id} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Facilities')} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddFacilityPopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortConfig={sortConfig}
        loader={loader}
        searchPlaceholder="Search facility ..."
        noOfItems={total}
      >
        {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      </ListLayout>
    </>
  )

}

const FacilityItem = ({
  facility, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(facility?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  React.useEffect(() => {
    setStatus(facility?.status || 0)

  }, [facility])
  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Facilities') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={facility.id} checked={selectedItems.includes(facility.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {facility.abbreviation}
      </td>
      <td style={getBackgroundStyle(status)}>
        {facility.phone}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTC(facility.created_at)}
      </td>
      {checkPermission('Status Facilities') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(facility?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Facilities') &&
        <td style={getBackgroundStyle(status)}>
          <div className="row_check">
            <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...facility, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}

export default Facility;